var uneSliders = document.querySelectorAll('.js-une-slider');

if (uneSliders.length > 0) {
    uneSliders.forEach(uneSlider => {
        if (uneSlider.classList.contains('splide')) {
            var gap = 30;

            var splideInstance = null;

            function initSlider() {

                if (splideInstance) {
                    splideInstance.destroy(true);
                    splideInstance = null;
                }
                if (window.matchMedia('(min-width: 30rem)').matches) {
                    splideInstance = new Splide(uneSlider, {
                        autoWidth: true,
                        perMove: 1,
                        gap: `${gap / 16}rem`,
                        snap: true,
                        pagination: false,
                        drag: true
                    });

                    splideInstance.on('overflow', function (isOverflow) {

                        splideInstance.go(0);

                        splideInstance.options = {
                            arrows: isOverflow,
                            drag: isOverflow,
                        };
                    });


                    splideInstance.mount();
                }

            }

            // Init au chargement
            initSlider();

            // Reinit au resize (avec debounce)
            var resizeTimeout;
            window.addEventListener('resize', () => {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(() => {
                    initSlider();
                }, 200);
            });

        }
    })
}
